import { useEffect } from "react";
import { getToken } from "firebase/messaging";
import { messaging } from "../firebase/config";
import { auth, db } from "../firebase/config";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

const useSaveFcmToken = () => {
  useEffect(() => {
    const saveToken = async () => {
      const user = auth.currentUser;
      if (!user) return;

      try {
        const token = await getToken(messaging, {
          vapidKey: "BCZSCigkuHTBWDzlKw2FoVOGXzRG-bHKMJXP322BOOz1vLFD31cmIQgUGgqUAdyJSpCWs2OiOmtkuVnQBDKFREc",
        });

        if (token) {
          const idTokenResult = await user.getIdTokenResult();
          const role = idTokenResult.claims.role || "customer";

          await setDoc(doc(db, "fcm_tokens", user.uid), {
            token,
            uid: user.uid,
            role,
            updatedAt: serverTimestamp(),
          });

          console.log("✅ FCM token saved for", role, user.uid);
        }
      } catch (error) {
        console.error("❌ Error saving FCM token:", error);
      }
    };

    saveToken();
  }, []);
};

export default useSaveFcmToken; 